import { Link } from "react-router-dom";
import { EDUCATION_TOPICS, BET_TYPES } from "@/lib/content";
import { BookOpen, ChevronRight, GraduationCap } from "lucide-react";
import ResponsibleBanner from "@/components/ResponsibleBanner";

export default function EducationPage() {
  return (
    <div className="max-w-[1500px] mx-auto px-4 sm:px-6 py-12 space-y-12">
      <div>
        <div className="text-xs font-bold tracking-[0.2em] text-smasher-orange mb-1">LEARN THE GAME</div>
        <h1 className="font-heading font-black uppercase text-4xl sm:text-5xl text-gradient-gold flex items-center gap-3"><GraduationCap className="w-10 h-10 text-smasher-gold" /> Sportsbook Education</h1>
        <p className="text-slate-400 mt-3 max-w-2xl">Understand sports wagers, odds, lines and strategy. These lessons are educational — they teach you how to analyze the game, not promises of guaranteed profit.</p>
      </div>

      <section>
        <h2 className="font-heading font-black uppercase text-2xl text-white mb-5">The Three Core Bet Types</h2>
        <div className="grid md:grid-cols-3 gap-5">
          {BET_TYPES.map((b) => (
            <div key={b.name} className="panel panel-hover p-6">
              <div className="font-mono-num text-smasher-gold/40 text-4xl font-bold">{b.n}</div>
              <h3 className="font-heading font-black text-xl text-smasher-gold mt-2">{b.name}</h3>
              <p className="text-sm text-slate-400 mt-2 leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="font-heading font-black uppercase text-2xl text-white mb-5 flex items-center gap-2"><BookOpen className="w-6 h-6 text-smasher-gold" /> All Topics</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {EDUCATION_TOPICS.map((t) => (
            <Link key={t.slug} to={`/education/${t.slug}`} className="panel panel-hover p-5 group" data-testid={`edu-topic-${t.slug}`}>
              <h3 className="font-heading font-bold text-lg text-white group-hover:text-smasher-gold transition">{t.title}</h3>
              <p className="text-sm text-slate-400 mt-1">{t.short}</p>
              <span className="text-xs text-smasher-gold font-bold mt-3 inline-flex items-center gap-1">READ <ChevronRight className="w-3.5 h-3.5" /></span>
            </Link>
          ))}
        </div>
      </section>

      <ResponsibleBanner />
    </div>
  );
}
